import { render } from "./ContentPage.vue?vue&type=template&id=1cb154b5&scoped=true"
import script from "./ContentPage.vue?vue&type=script&lang=js"
export * from "./ContentPage.vue?vue&type=script&lang=js"

import "./ContentPage.vue?vue&type=style&index=0&id=1cb154b5&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb154b5"]])

export default __exports__